import React from 'react';
import { getDataSession } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable'
import { useTranslation } from "react-i18next";
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';

const Mensajes = ({ match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { t } = useTranslation("common");
    const { path } = match;

    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "editar" },
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'usuario_Id', headerName: 'Usuario', flex: 1 },
        { field: 'pregunta', headerName: 'Mensaje', flex: 1 },
        { field: 'estatusMensaje', headerName: 'Estatus', flex: 1 },
        { field: 'tipoMensaje', headerName: 'Tipo Mensaje', flex: 1 },
    ];

    React.useEffect(() => {
        changeGlobalTitle(t('app.Mensajes.title'), t('app.Mensajes.subtitle'))
    }, [changeGlobalTitle, t]);

    return (
        <>
            <div className='container-fluid'>

                <div className='col-md-12'>
                    <ListTable
                        columns={columns}
                        path={path}
                        url={`MensajesEcommerce/MensajesGetList?sucursal_Id=${getDataSession('sucursal')}`}
                    />
                </div>
            </div>
        </>
    );
};

export { Mensajes };
